export default "__VITE_ASSET__B7d6x99Q__"